export default __webpack_public_path__ + "static/media/arrow-category.928fb3d1.svg";